import { Pipe, PipeTransform } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';
import { CurrencyPipe } from '@angular/common';
import { ProviderSettingsService } from '@core/services';

@Pipe({
  name: 'localizedCurrency',
  pure: false,
})
export class LocalizedCurrencyPipe implements PipeTransform {
  constructor(
    private translateService: TranslateService,
    private providerSettingsService: ProviderSettingsService,
  ) {}

  transform(value: string | number, currencyCode?: string, digitInfo?: string): string | null {
    const currencyPipe: CurrencyPipe = new CurrencyPipe(this.translateService.currentLang);
    if (!currencyCode) {
      // Fallback to the default currency from provider settings
      currencyCode = this.providerSettingsService.getProviderGeneralData().default_currency || 'EUR';
    }
    return currencyPipe.transform(value, currencyCode, 'symbol', digitInfo);
  }
}
